
export const BASE_CLS = 'phase-1-history-editor-page';